import styled from 'styled-components';

export const FooterWrapper = styled.div<{ $isBaymax?: boolean }>`
  display: flex;
  justify-content: space-between;
  background-color: ${({ theme, $isBaymax }): string =>
    $isBaymax ? theme.admanColors!.gray.light.bg3[4] : theme.admanColors!.gray.light.fg[6]};
  border-top: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg3[2]};
  font: 400 12px ${({ $isBaymax }): string => ($isBaymax ? 'InspireTWDC' : 'Graphik')};
  color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[3]};
  height: 68px;
  max-width: 100vw;
`;

export const FooterCopyrightYear = styled.div`
  font-weight: 500;
`;

export const FooterContentRight = styled.div`
  margin: ${({ theme }): string => theme.spacers!.spacer06} ${({ theme }): string => theme.spacers!.spacer09};
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    margin-left: ${({ theme }): string => theme.spacers!.spacer06};
    color: ${({ theme }): string => theme.colors!.colorGray2};
    letter-spacing: 0.01em;
    text-decoration: none;
  }
`;

export const FooterContentLeft = styled.div`
  display: flex;
  align-items: center;
`;
